<template>
  <div>
    <img class="block" :src="replaceInImageTemplate(url, actualSize)"
         :srcset="replaceInImageTemplate(url, actualSize) + ' 1x,' + replaceInImageTemplate(url, actualSize, 2) + ' 2x,' + replaceInImageTemplate(url, actualSize, 3) + ' 3x'" :alt="alt">
  </div>
</template>

<script>
  import helpers from '@/mixins/helpers.js'
  import {EventBus} from '@/assets/js/event-bus.js'

  export default {
    name: 'ImgComp',
    props: {
      element: {
        type: Object,
        required: true
      },
      size: {
        type: String,
        default: 'xl'
      },
      alt: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        desktopSize: 'D',
        url: ''
      }
    },
    mixins: [helpers],
    created () {
      EventBus.$on('sizeBreakPoint', () => {
        this.updateImageUrl()
      })
      this.updateImageUrl()
    },
    methods: {
      updateImageUrl () {
        var screenWidth = window.innerWidth
        if (screenWidth < 712) {
          this.desktopSize = 'S'
        } else if (screenWidth < 1300) {
          this.desktopSize = 'T'
        } else {
          this.desktopSize = 'D'
        }
        this.url = this.getImageTemplateFromObject(this.element)
      }
    },
    computed: {
      actualSize () {
        return this.desktopSize + '_' + this.size
      }
    },
    watch: {
      element: function () {
        this.updateImageUrl()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Image.vue